import { isLiveVisible, liveFreshness, LIVE_TYPES, type LiveType } from "@oshimap/domain";
import { relativeDay } from "@oshimap/utils";
import { ep } from "../../lib/api";
import { useQuery } from "../../lib/use-query";
import { useVisibleRefresh } from "../../lib/use-refresh";
import { liveDetail } from "./format";
import "./live.css";
import { queryKeys } from "@oshimap/query";

const SHORT: Record<LiveType, string> = {
  WAIT_TIME: "대기", SOLD_OUT: "품절", RESTOCK: "재입고", BENEFIT_ENDED: "특전 소진",
  BOOKING_CLOSED: "예약 마감", TEMP_CLOSED: "임시 휴업", NORMAL: "평소와 같음",
};
const TONE: Record<LiveType, string> = {
  WAIT_TIME: "warn", SOLD_OUT: "stop", RESTOCK: "good", BENEFIT_ENDED: "stop",
  BOOKING_CLOSED: "stop", TEMP_CLOSED: "stop", NORMAL: "good",
};

/**
 * 고르는 순간에 보이는 한 줄.
 *
 * "어디로 갈까" 를 정하는 곳은 상세 화면이 아니라 **이 카드**다.
 * 그래서 가장 최근 소식 하나만, 값과 시각만 짧게 보여준다.
 * 자세한 건 상세에서 본다 — 여기서 다 보여주면 고르는 일을 방해한다.
 */
export function LiveGlance({ placeId }: { placeId: string }) {
  const list = useQuery(queryKeys.placeLive(placeId), (signal) => ep.listPlaceLive(placeId, { signal }));
  useVisibleRefresh(60, list.reload);

  if (list.state.status !== "success") return null;
  const live = list.state.data.filter((u) => isLiveVisible(u));
  const latest = live[0];
  if (!latest) return null;

  const type = (LIVE_TYPES as readonly string[]).includes(latest.type) ? (latest.type as LiveType) : null;
  const detail = liveDetail(latest);

  return (
    <span className={`om-glance om-glance--${type ? TONE[type] : "plain"}`}>
      <b>{type ? SHORT[type] : latest.type}{detail ? ` ${detail}` : ""}</b>
      {/* 값만 있으면 믿을 수 없다. 언제 본 것인지가 값의 뜻을 정한다. */}
      <time className="num" dateTime={latest.observedAt}>{relativeDay(latest.observedAt)}</time>
      {liveFreshness(latest) < 0.25 ? <span className="om-glance__old">오래됨</span> : null}
    </span>
  );
}
